import React, { useState, useEffect } from "react";

import {
    Box,
    Divider,
    Grid,
    Typography,
    Button,
    styled,
    Card,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TableFooter,
    Checkbox,
    TextField,
    IconButton,
    InputAdornment,
    SpeedDial,
    SpeedDialAction,
    Badge
} from '@mui/material';

import { useNavigate } from "react-router-dom";

// import { useDocuments, documentTypes, targetTypes } from "../../../hooks/api/useDocuments";
import { useInventories, inventoriesTypes } from "../../../hooks/api/useInventories";
import { useSystemPrompt } from "../../../hooks/useSystemPrompt";
import { useSystemUtils } from "../../../hooks/useSystemUtils";
import { useAppContextFeatures } from "../../../context/AppContext";
import { useSystemRoutes, routeTypes } from "../../../hooks/useSystemRoutes";
import { useSystemHead, headTitles } from '../../../hooks/useSystemHead';
import { usePermissions, scopeIds, scopeTypes, functionTypes } from "../../../hooks/usePermissions";
import { useTranslations } from '../../../hooks/useTranslations';
import { useSelectable } from "../../../hooks/useSelectable"

import { useDataTransitions, transitionTypes } from "../../../hooks/state/dataTransition/useDataTransitions";

import CommonSectionHeader from "../../common/CommonSectionHeader";
import CommonBreadcumbs from "../../common/CommonBreadcumbs";
import { CommonIcons, icons } from "../../common/CommonIcons";
import CommonRestricted from "../../common/CommonRestricted";

import LocationSelector from "../../selector/LocationSelector"

// import { CommonPdf, renderModes, documentTypes as commonPdfDocumentTypes } from "../../common/CommonPdf";

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(2)
}));

export const StyledIcon = styled(Box)({
    width: 20,
    height: 20,
    textAlign: 'center',
    alignItems: 'center',
    justifyContent: 'center',
});

const StyledSpeedDial = styled(SpeedDial)(({ theme }) => ({
    position: 'absolute',
    '&.MuiSpeedDial-directionUp, &.MuiSpeedDial-directionLeft': {
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    '&.MuiSpeedDial-directionDown, &.MuiSpeedDial-directionRight': {
        top: theme.spacing(2),
        left: theme.spacing(2),
    },
}));

const RenderFormLocation = ({ t, locationDisplay, onReset }) => {

    return (
        <StyledCard>
            <Grid container spacing={1}>
                <Grid item xs={6} sm={6} md={6} textAlign={"left"}>

                    <CommonSectionHeader
                        title={t(`location`)}
                        subTitle={t(`relatedWarehouseLocationToProcess`)}
                    />

                </Grid>
                <Grid item xs={6} sm={6} md={6}>
                    <TextField
                        disabled
                        margin="dense"
                        size="small"
                        fullWidth
                        // name={"locationId"}
                        label={t("location")}
                        type="text"
                        variant="outlined"
                        value={locationDisplay}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <IconButton
                                        color="primary"
                                        sx={{
                                            // pt: 0
                                        }}
                                        onClick={onReset}
                                    >
                                        <StyledIcon
                                            sx={{
                                                width: 25,
                                                height: 25,
                                                m: 0,
                                                p: 0
                                            }}
                                        >
                                            <CommonIcons name={icons.edit} />
                                        </StyledIcon>
                                    </IconButton>
                                </InputAdornment>
                            )
                        }}
                    // error={touched.locationId && Boolean(errors.locationId)}
                    // helperText={touched.locationId && errors.locationId}
                    />
                </Grid>

            </Grid>
        </StyledCard>
    )
}

const RenderTable = ({ t, data, handleSelectAll, handleSelectRow, isSelectAll, selectedKeys }) => {

    if (!data) return <></>

    return (
        <TableContainer
            // component={Paper}
            sx={{
                // minHeight: 400,
                // maxHeight: 400
            }}
        >
            <Table
                size="small"
                stickyHeader
            >
                <TableHead>
                    <TableRow>
                        <TableCell width={20}>#</TableCell>
                        <TableCell>
                            {/* {JSON.stringify(isSelectAll)} */}
                            <Checkbox onClick={handleSelectAll} checked={isSelectAll === true} size="small" />
                        </TableCell>
                        <TableCell>{t('name')}</TableCell>
                        <TableCell width={100}>{t('code')}</TableCell>
                        {/* <TableCell>Description</TableCell> */}
                        <TableCell align="right">{t('availableQty')}</TableCell>
                        <TableCell align="center">{t('threshold')}</TableCell>
                        <TableCell align="right">{t('suggestQty')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {
                        data.map((row, index) => {

                            let checked = Boolean(row._selected)

                            return (
                                <TableRow key={index}>
                                    <TableCell>{(index + 1)}</TableCell>
                                    <TableCell width={20}>
                                        {/* {JSON.stringify(row.id)}
                                        {JSON.stringify(row._selected)} */}
                                        <Checkbox
                                            onClick={() => {
                                                handleSelectRow({ row })
                                            }}
                                            checked={checked}
                                            size="small"
                                        />
                                    </TableCell>
                                    <TableCell>{row.item_name}</TableCell>
                                    <TableCell>{row.code}</TableCell>
                                    {/* <TableCell>{row.item_description}</TableCell> */}
                                    <TableCell align="right">
                                        {
                                            `${parseFloat(row.total_remain_qty)} ${row.uom_name}`
                                        }
                                    </TableCell>
                                    <TableCell>
                                        <Box
                                            display={"flex"}
                                            flexDirection={"row"}
                                            justifyContent={"space-between"}
                                            alignItems={"center"}
                                        >
                                            <CommonIcons name={icons.threshold} />
                                            <Typography>
                                                {`${parseFloat(row.reorder_threshold_qty)}`}
                                            </Typography>
                                            <CommonIcons name={icons.chevronUp} />
                                            <Typography>
                                                {`${parseFloat(row.reorder_topup_qty)}`}
                                            </Typography>
                                        </Box>

                                    </TableCell>
                                    <TableCell align="right">
                                        {
                                            `${parseFloat(row.suggest_qty)} ${row.uom_name}`
                                        }
                                    </TableCell>
                                </TableRow>
                            )
                        })

                    }
                </TableBody>
            </Table>
        </TableContainer>
    )
}

const RenderForm = ({
    t,
    data,
    locationDisplay,
    onResetLocation,
    onBack,
    onTransition,
    handleSelectAll,
    handleSelectRow,
    isSelectAll,
    selectedKeys
}) => {

    if (!data) return <></>

    return (
        <>
            {/* <Grid container spacing={1}>
                    <Grid item xs={12} sm={12} md={5} textAlign={"left"}>
                        {
                            RenderFormDocument()
                        }
                    </Grid>
                    <Grid item xs={12} sm={12} md={7} textAlign={"left"}>
                        {
                            RenderFormProfile()
                        }
                    </Grid>
                </Grid> */}

            <Grid container spacing={0}>
                <Grid item xs={12} sm={12} md={12} textAlign={"left"}>
                    <RenderFormLocation
                        t={t}
                        locationDisplay={locationDisplay}
                        onReset={onResetLocation}
                    />
                </Grid>
            </Grid>

            {/* <Box
                    sx={{
                        textAlign: 'left',
                        mt: 3,
                        pl: 0.5,
                    }}
                >
                    <CommonSectionHeader
                        title={`Items`}
                        subTitle={`Detail information about the items involved`}
                    />
                </Box> */}

            <StyledCard
                sx={{
                    mt: 1.5,
                    p: 0
                }}
            >
                <Grid container rowSpacing={0}>
                    <Grid item md={12}>
                        <RenderTable
                            t={t}
                            data={data}
                            handleSelectAll={handleSelectAll}
                            handleSelectRow={handleSelectRow}
                            isSelectAll={isSelectAll}
                            selectedKeys={selectedKeys}
                        />
                    </Grid>
                    {/* <Grid item md={12}>
                            <RenderTableFooter />
                        </Grid> */}

                </Grid>
            </StyledCard>
            {/* <Grid container spacing={1} sx={{ pl: 2, pr: 2 }}>
                <Grid item md={12} textAlign={"center"}>
                    <Button
                        type="button"
                        variant="contained"
                        sx={{
                            mt: 3,
                            mb: 2
                        }}
                        onClick={onBack}
                    >
                        {t('back')}
                    </Button>
                </Grid>
            </Grid> */}

            {/* {JSON.stringify(selectedKeys)} */}

            <StyledSpeedDial
                ariaLabel={`${t("reorderThresholdToPurchaseOrder")}`}
                sx={{ position: 'fixed', bottom: 16, right: 16 }}
                icon={
                    <Badge badgeContent={selectedKeys.length} color="error">
                        <CommonIcons name={icons.transition} />
                    </Badge>
                }
                direction="left"
            >
                <SpeedDialAction
                    icon={
                        <CommonIcons name={icons.documents} />
                    }
                    title={`${t("addToPurchaseOrder")}`}
                    tooltipTitle={`${t("addToPurchaseOrder")}`}
                    onClick={onTransition}
                />
            </StyledSpeedDial>

        </>
    )
}

export default function ViewItemReorderThreshold({
    routeType
}) {
    const { t } = useTranslations({ ns: ["common", "@operation", "@document", "prompt"] })

    // const { id } = useParams();

    const { setSystemLoading, getLocationIds, setLocationIds } = useAppContextFeatures();

    const { promptMessage } = useSystemPrompt();

    const { list, filterOperatorTypes } = useInventories({ inventoriesType: inventoriesTypes.reorderThreshold });

    // const { formatCurrencyDisplay, currencyAbb } = useSystemUtils();
    const { getRoute } = useSystemRoutes(routeType)
    const { getHtmlHead } = useSystemHead(routeType)
    const { isPermissionAllow } = usePermissions(routeType, scopeIds.operation.id, scopeTypes.operation.itemReorderThreshold.id)

    const {
        initialTransition
    } = useDataTransitions({ transitionType: transitionTypes.fromReorderThresholdToPurchaseOrder.id })

    const {
        selectableData,
        setSelectableData,
        isSelectAll,
        handleSelectAll,
        handleSelectRow,
        // getRowSelectStatus,
        totalRowSelected,
        selectedKeys
    } = useSelectable({ primaryKey: 'id' })

    const navigate = useNavigate();

    // const [data, setData] = useState()

    const [locationId, setLocationId] = useState("")
    const [locationDisplay, setLocationDisplay] = useState("")

    // const selectedLocationId = getLocationIds()

    const fetchData = async () => {

        setSystemLoading(true);

        try {

            let filterValues = [{
                name: "location_id",
                operator: filterOperatorTypes.eq,
                value: locationId,
            }]

            let props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "id",
                    dir: 0,
                },
                filterValue: filterValues,
                // filterValue: [],
                dataTypes: ["group_location"]
            }

            let { data } = await list(props);

            let _data = data?.inventories ? data.inventories : []

            // setData(_data)

            setSelectableData(_data)

        } catch (error) {
            promptMessage(false, `${error.message}`)
        }

        setSystemLoading(false)

    }

    const onTransition = async () => {

        let transitionData = []

        selectedKeys.forEach(i => {

            let _item = selectableData.filter(i2 => i2.id.toString() === i.toString())

            // console.log('_item', selectableData, i, _item)

            if (_item.length > 0) {
                transitionData.push({
                    itemId: _item[0].id,
                    suggestQty: _item[0].suggest_qty
                })
            }

        })

        // console.log('transitionData', transitionData)

        let { nextRoute, nextRouteParams } = initialTransition({ data: { locationId, locationDisplay, items: transitionData } })

        // console.log('111', getRoute(nextRoute))

        navigate(getRoute(nextRoute), nextRouteParams);

    }

    useEffect(() => {

        if (validateLocationSelection()) {
            fetchData();
        } else {
            // setData([])
        }

    }, [locationId])

    const validateLocationSelection = () => {
        // return (selectLocationIds && selectLocationIds.length === 1)
        // const selected = getLocationIds()
        // const selected = selectedLocationId
        // return selected && selected.length === 1
        return Boolean(locationId)
    }

    const getBreadcumbActionMenus = () => {

        let props = []

        // if (isPermissionAllow({ functionType: functionTypes.pageUpdate.id })) {
        //     props.push({
        //         displayText: "Edit Document",
        //         href: getRoute(`documents/deliveryOrder/update/${id}`),
        //         // onClick: () => {
        //         //     navigate(getRoute(`documents/salesOrder/update/${id}`))
        //         // }
        //     })
        // }

        // if (isPermissionAllow({ functionType: functionTypes.pageView.id })) {

        //     props.push({
        //         displayText: "Print Preview",
        //         onClick: () => {

        //             openCustomDrawer({
        //                 show: true,
        //                 anchor: "right",
        //                 title: `Preview PDF`,
        //                 PaperProps: {
        //                     sx: { width: 2 / 3 }
        //                 },
        //                 // handleOnClose: () => setPreviewPdfOpen(false),
        //                 ComponentActions: <></>,
        //                 ComponentBody:
        //                     <CommonPdf
        //                         routeType={routeType}
        //                         renderMode={renderModes.preview.id}
        //                         documentType={commonPdfDocumentTypes.itemReorderThreshold.id}
        //                         document={{
        //                             title: data?.document?.doc_number
        //                         }}
        //                         data={data}
        //                     // customData={{
        //                     //     items: data
        //                     // }}
        //                     />
        //             })

        //             return true;

        //         }
        //     })

        // }

        return props

    }

    return (
        <Box>
            {
                getHtmlHead({ routeType, title: headTitles.itemReorderThreshold })
            }

            {/* {JSON.stringify(selectableData)} */}
            <CommonBreadcumbs
                routeType={routeType}
                pageTitle={t(`reorderThresholdControl`)}
                actionMenus={
                    getBreadcumbActionMenus()
                }
                breadcrumbs={[
                    // {
                    //     displayText: "Purchase Orders",
                    //     props: {
                    //         href: getRoute("documents/purchaseOrders")
                    //     }
                    // },
                    {
                        displayText: t(`reorderThresholdControl`),
                        props: {
                            color: 'secondary.main',
                        }
                    },
                ]}
            />

            {
                isPermissionAllow({ functionType: functionTypes.pageView.id }) ?
                    validateLocationSelection() ?
                        (
                            <RenderForm
                                t={t}
                                navigate={navigate}
                                data={selectableData}
                                locationId={locationId}
                                locationDisplay={locationDisplay}
                                onBack={() => navigate(-1)}
                                onResetLocation={() => {
                                    // setLocationIds([])
                                    setLocationId("")
                                    setLocationDisplay("")
                                }}
                                onTransition={onTransition}
                                handleSelectAll={handleSelectAll}
                                handleSelectRow={handleSelectRow}
                                isSelectAll={isSelectAll}
                                selectedKeys={selectedKeys}
                            />
                        )
                        :
                        (
                            <LocationSelector
                                config={{
                                    title: t("selectOnly1Location"),
                                    description: t("youHaveToSelectAnyoneOfTheWarehouseLocationToProceed")
                                }}
                                maxSelect={1}
                                handleOnNext={({ selected }) => {

                                    // console.log('selected', selected)

                                    // setLocationIds([selected[0].id])
                                    // setFieldValue(`locationId`, selected[0].id)
                                    // setFieldValue(`locationName`, selected[0].location_name)
                                    setLocationId(selected[0].id)
                                    setLocationDisplay(selected[0].location_name)

                                }}
                            />
                        )
                    :
                    <CommonRestricted />
            }

        </Box>
    )
}